"use client";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { TagSelectInput } from "./TagSelectInput";
import { useJobFilterStore } from "../../store/useJobFilterStore";
import { useCandidateProfileStore } from "../../store/useCandidateProfileStore";
import { useSkillStore } from "../../store/useSkillStore";

type SkillItem = { skillName: number };

type Props = {
  onClose: () => void;
  setSkill: (data: SkillItem[]) => void;
  defaultData: SkillItem[]; // incoming array like [{ skillName: 3 }, ...]
};

export default function EditSkillForm({ onClose, setSkill, defaultData }: Props) {
  const location = useLocation();
  const lang = location.pathname.startsWith("/id") ? "id" : "en";
  const { skillSet = [], fetchFilters } = useJobFilterStore();

  // skill options for TagSelectInput: { id, name }
  const skillOptions = (skillSet ?? []).map((item: any) => ({
    id: item.id,
    name: item.name,
  }));

  // store selected IDs (TagSelectInput expects array of ids)
  const [selectedSkillIds, setSelectedSkillIds] = useState<number[]>([]);

  // fetch options
  useEffect(() => {
    fetchFilters(lang, "skillSet");
  }, [lang, fetchFilters]);

  // when skill options or defaultData arrive, set initial selected IDs
  useEffect(() => {
    if (!Array.isArray(defaultData)) {
      setSelectedSkillIds([]);
      return;
    }

    // defaultData: [{ skillName: number }, ...]
    const initialIds = defaultData
      .map((d) => Number(d.skillName))
      .filter((n) => !Number.isNaN(n));

    setSelectedSkillIds(initialIds);
  }, [defaultData]);

  
  const { fetchCandidateProfile } = useCandidateProfileStore();
  const { updateSkills, loading } = useSkillStore();
  const handleSave = async () => {
  const result: SkillItem[] = selectedSkillIds.map((id) => ({
    skillName: id,
  }));

  const success = await updateSkills(result);

  if (success) {
      fetchCandidateProfile();
    setSkill(result); // update UI parent
    onClose();
  }
};


  return (
    <div className="space-y-6 pb-4">

      <TagSelectInput
        label="Skills"
        value={selectedSkillIds}
        onChange={setSelectedSkillIds}
        options={skillOptions}
      />

      <div className="flex justify-center gap-4 pt-4">
        <button
          onClick={onClose}
          className="px-6 py-3 rounded-lg border text-gray-500 font-semibold"
        >
          {lang === "id" ? "Batal" : "Cancel"}
        </button>
        <button
          onClick={handleSave}
          className="px-6 py-3 rounded-lg bg-primary text-white font-semibold"
        >
          {lang === "id" ? "Simpan" : "Save"}
        </button>
      </div>
    </div>
  );
}
